export default __webpack_public_path__ + "static/media/work-4.b5bc7642.jpg";